export default "__VITE_ASSET__B3WQBH2u__"